<template>
  <div class="sum flex flex-col items-center">
    <button
      v-if="error"
      v-scroll-to="'#step-2'"
      class="btn mt-8 mb-4 px-12 py-4 flex items-center animate"
      @click="goToForm"
    >
      {{ $t('summary.goToSummary') }}
    </button>
    <button
      v-else
      class="btn mt-8 mb-4 px-12 py-4 flex items-center animate"
      @click="goToForm"
    >
      {{ $t('summary.goToSummary') }}
    </button>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';
import { SUMMARY } from '@/router/routes.names';

export default {
  name: 'Step5',
  props: {
    activeStep: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState('order', ['subcategory_id', 'subcategories', 'bonuses', 'extras', 'tastes', 'sum', 'error', 'europln']),
    ...mapGetters('order', ['chosenCategoryObj']),
    ...mapGetters('pref', ['getLang']),
    orderPrice() {
      let base = 0;
      let bonusPrice = 0;
      if (this.chosenCategoryObj) {
        base += this.chosenCategoryObj.price_pln;
        Object.keys(this.extras).forEach((el) => {
          if (this.extras[el]) {
            bonusPrice += this.bonuses[el].price_pln;
          }
        });

        return this.convertCurrency(this.sum, bonusPrice, base);
      }

      return 0;
    },
    sum() {
      let sum = 0;
      this.tastes.forEach((el) => {
        sum += Number(el.quantity);
      });

      return sum;
    },
    currency() {
      return this.getLang === 'en' ? 'euro' : 'zł';
    },
    lang() {
      return this.getLang === 'en' ? 'en' : 'pl';
    },
  },
  mounted() {
    this.setDirty(null);
    this.setError(this.$t('order.numberError'));
  },
  methods: {
    ...mapMutations('order', ['setOrderPrice', 'setError', 'setDirty', 'setCurrency', 'setLang']),
    goToForm() {
      this.setOrderPrice(this.orderPrice);
      this.setCurrency(this.currency);
      this.setLang(this.lang);
      if (this.sum === this.chosenCategoryObj.quantity_in_package) {
        this.$router.push({ name: SUMMARY });
        this.setError(null);
      } else {
        this.setError(this.$t('order.numberError'));
        this.setDirty(true);
      }
    },
    convertCurrency(sum, bonusPrice, base) {
      return this.getLang === 'en' ? (((sum + bonusPrice) * base) / this.europln).toFixed(2) : ((sum + bonusPrice) * base).toFixed(2);
    },
  },
};
</script>
